import { call, put, cancelled } from 'redux-saga/effects';
import Debug from 'debug';

const error = Debug('createPromiseSaga:error');

const REQUEST = 'REQUEST';
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';
const CANCELED = 'CANCELED';

export default function promiseSaga(action, fn, ...args) {
  return function*() {
    try {
      yield put({ ...action, type: `${action.type}_${REQUEST}` });
      const result = yield call(fn, ...args);
      yield put({
        ...action,
        type: `${action.type}_${SUCCESS}`,
        payload: result,
      });
    } catch (err) {
      error(err);
      const payload = { ...err };
      if (err.message) {
        payload.message = err.message;
      }
      if (err.stack) {
        payload.stack = err.stack;
      }
      yield put({
        ...action,
        type: `${action.type}_${FAILURE}`,
        error: payload,
      });
    } finally {
      if (yield cancelled()) {
        yield put({ ...action, type: `${action.type}_${CANCELED}` });
      }
    }
  };
}
